export default "__VITE_ASSET__2$WITpKg__"